var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-credentials-card",class:{ disabled: !_vm.enabled },on:{"click":function($event){_vm.enabled && _vm.addNewCredentials()}}},[_c('img',{staticClass:"plus-image",attrs:{"src":"/images/onboarding/icons/icon-add.svg"}}),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }